// extracted by mini-css-extract-plugin
export default {"rowCursor":"TableBody_rowCursor__wKMFj","tableBody":"TableBody_tableBody__sLbo6","selectedColor":"TableBody_selectedColor__meQj6","isSelected":"TableBody_isSelected__zSLNA"};